<template>
    <PublicLandingPage :page="landingPages.hungarianCakes" />
</template>

<script setup lang="ts">
import { landingPages } from '~/fixtures';
</script>
